let obj = {};
obj.guarantPre = [
  {
    key: 1,
    value: '1个月'
  },
  {
    key: 3,
    value: '3个月'
  },
  {
    key: 6,
    value: '6个月'
  },
  {
    key: 12,
    value: '12个月'
  }
];
// 证件类型
obj.IdTypeOptions = [
  {
    name: '身份证',
    value: 1
  },
  {
    name: '护照',
    value: 4
  },
  {
    name: '港澳台居民居住证',
    value: 6
  }
];
obj.companyIdTypeOptions = [
  {
    value: 14,
    name: '组织机构代码'
  },
  {
    value: 13,
    name: '社会信用代码'
  },
  {
    value: 15,
    name: '个体经营者营业执照'
  }
];
// 性别
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  }
];
obj.KZSCOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  }
];
// 客运民航意外
obj.oneSCOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
// 客运轨道交通意外
obj.SHHLOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
//客运轮船意外
obj.KYLCYWOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
//客运汽车意外
obj.KYQCYWOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
//驾乘意外（非营运车辆）
obj.JCYWOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 50000,
    name: '5万'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 150000,
    name: '15万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 250000,
    name: '25万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 350000,
    name: '35万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 450000,
    name: '45万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
obj.columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '姓名',
    dataIndex: 'name'
  },
  {
    title: '证件类型',
    dataIndex: 'idType',
    key: 'idType',
    scopedSlots: { customRender: 'idType' }
  },
  {
    title: '证件号码',
    dataIndex: 'idNumber'
  },
  {
    title: '出生日期',
    dataIndex: 'birthDate'
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    scopedSlots: { customRender: 'gender' }
  },
  {
    title: '职业代码',
    dataIndex: 'occupationCode'
  },
  {
    title: '职业名称',
    dataIndex: 'occupationName'
  },
  {
    title: '职业类别',
    dataIndex: 'occulevel',
    key: 'occulevel',
    scopedSlots: { customRender: 'occulevel' }
  }
];
export default { ...obj };
